// api.js

import axios from "axios";
const apiDomain = process.env.REACT_APP_API_URL;

const api = {
  url: apiDomain,
  cookieDomain: apiDomain.replace(/https?:\/\/(api||app)?/,"").replace(/:\d+$/,""),  // `.vetmanaged.com` or `.vetmanaged.loc`.  // prefix `.` shares cookie between root & subdomains ('app.' or 'api.' is removed).

  login:                    "/m/api/login",    // POST
  logout:                   "/m/api/logout",   // POST
  locationdata:             "/m/api/location/{locationkey}",   // GET
  register:                 "/m/api/register",   // POST
  registerconfirm:          "/m/api/register_confirm",   // POST
  registercomplete:         "/m/api/register_complete",   // POST
  logout:                   "/m/api/logout",   // POST
  passwordreset:            "/m/api/passwordreset",   // POST
  passwordresetconfirm:     "/m/api/passwordreset_confirm",   // POST
  passwordresetcomplete:    "/m/api/passwordreset_complete",   // POST
  session:                  "/m/api/me",

  // CLIENT PROFILE (User)
  getClientProfile:         "/m/api/me",  // GET
  updateClientProfile:      "/m/api/me",  // POST

  getClientProfileImage:    "/m/api/profile/image/{profile_image_id}",  // GET
  uploadClientProfileImage: "/m/api/newProfileImageTemp",  // POST

  getPatients:              "/m/api/patients",
  setPatient:               "/m/api/patient",  // POST

  getPatientImage:          "/m/api/profile/image/{profile_image_id}",
  uploadPatientImage:       "/m/api/newProfileImageTemp",  // POST

  getPatientRecordsPdf:     "/m/api/patient/{patient_id}/records_pdf",
  getPatientVaccsPdf:       "/m/api/patient/{patient_id}/vaccs_pdf",

  getSpecies:               "/m/api/species",
  getBreeds:                "/m/api/breeds/{species_id}",

  getLocations:             "/m/api/locations",
  getAppointentTypes:       "/m/api/appointment/types",
  getAppointments:          "/m/api/appointments",
  getAppointentSlots:       "/m/api/appointment/openings",

  scheduleAppointment:      "/m/api/appointment/create",  // POST
  updateAppointment:        "/m/api/appointment/update",  // POST
  cancelAppointment:        "/m/api/appointment/cancel",  // POST

};


const axiosConfig = {
  baseURL: apiDomain,
  timeout: 5000,
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/x-www-form-urlencoded",   // for POST only. This is ignored in GET requests.
    // "_ts": (new Date()).toISOString(),  // ⬅ This is causing preflight and it's being cors rejected.
    // "_tz": (new Date()).getTimezoneOffset()/60,
    // "Referrer-Policy": "strict-origin-when-cross-origin",
    // "Referrer-Policy": "no-referrer-when-downgrade",
  },
  withCredentials: true,
  exposedHeaders: ["Set-Cookie", "set-cookie"]
};

// Rewrite .get with a more friendly async/await raw awaited passthrough.
axios._get = axios.get;
axios.get = async (apiUrl, config) => {
  const useConfig = {...axiosConfig, ...config};
  try {
    const axConfig = { url: apiUrl, method: "get", ...useConfig };
    const resp = await axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

// Rewrite .post with a more friendly async/await raw awaited passthrough.
axios._post = axios.post;
axios.post = (apiUrl, postData, config) => {
  const useConfig = {...axiosConfig, ...config};
  try {
    const axConfig = { url: apiUrl, method: "post", data: postData, ...useConfig };
    const resp = axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

// Rewrite .put with a more friendly async/await raw awaited passthrough.
// const axiosFormDataConfig = {
//   baseURL: apiDomain,  // This gets ignored if the 'apiUrl' below is a complete URL.
//   timeout: 6000000,
//   headers: {
//     "Accept": "application/json",
//     "Content-Type": "multipart/x-www-form-urlencoded"   // for POST only. This is ignored in GET requests.
//   },
//   withCredentials: true,
//   exposedHeaders: ["Set-Cookie", "set-cookie"]
// };

const axiosFormDataConfig = JSON.parse(JSON.stringify(axiosConfig))
axiosFormDataConfig.timeout = 6000000;

axios.postFile = (apiUrl, formData, onUploadProgressCallback, config) => {
  const useConfig = {...axiosFormDataConfig, ...config};
  if (!!onUploadProgressCallback && typeof(onUploadProgressCallback)==="function") {
    useConfig.onUploadProgress = onUploadProgressCallback;
  }
  try {
    const axConfig = { url: apiUrl, method: "post", data: formData, ...useConfig };
    const resp = axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

export {
  api,
  axios
};